import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getAllVenueBySlug, updateEventVenue, getAllEvents, getEventById } from "../../../api";
import { createVenue, deleteVenue } from "../../../api";
import NormalTable from "../../../components/common/Tables/NormalTable";
import * as Yup from "yup";
import { useFormik } from "formik";
import { PulseLoader } from 'react-spinners';
import { toast } from "react-toastify";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ListCard from "../../../components/common/ListCard/ListCard";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { useNightMode } from "../../../contexts/NightModeContext";
import Background from "../../Login/Background";
import PageHeader from "../../../components/common/PageHeader/PageHeader";
const Venue = () => {
  const { isNightMode } = useNightMode();
  const { slug, eventId } = useParams();
  const [ticket, setTicketList] = useState<any>([]);
  const [search, setSearch] = useState("");
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [isLoading, setIsLoading] = useState(true);
  const [editModal, setEditModal] = useState<boolean>(false);
  const toggleEditModal = () => setEditModal(!editModal);
  const [editData, setEditData] = useState<any>(null);

  useEffect(() => {
    getTicketList();
  }, [slug, eventId]);

  const getResolvedSlug = async (targetId?: string): Promise<string> => {
    const idToFind = targetId || eventId || slug;
    const eventData = localStorage.getItem("eventData");
    if (eventData) {
      try {
        const parsed = JSON.parse(eventData);
        if (
          parsed.slugId &&
          isNaN(Number(parsed.slugId)) &&
          (!idToFind || String(parsed.eventId) === String(idToFind) || String(parsed.slugId) === String(idToFind))
        ) {
          return parsed.slugId;
        }
      } catch (e) {}
    }
    if (idToFind && isNaN(Number(idToFind))) {
      return idToFind;
    }
    if (idToFind) {
      try {
        const eventDetails = await getEventById(idToFind);
        if (eventDetails && eventDetails.slugId) {
          localStorage.setItem("eventData", JSON.stringify(eventDetails));
          return eventDetails.slugId;
        }
      } catch (err) {
        console.error("Error fetching event by ID:", err);
      }
    }
    try {
      const res: any = await getAllEvents();
      const list = Array.isArray(res) ? res : res?.data || [];
      const found = list.find(
        (e: any) => String(e.eventId) === String(idToFind) || String(e.id) === String(idToFind)
      );
      if (found) {
        localStorage.setItem("eventData", JSON.stringify(found));
        if (found.slugId) return found.slugId;
      }
    } catch (err) {
      console.error("Error resolving slugId:", err);
    }
    return idToFind || "";
  };

  const getTicketList = async () => {
    try {
      setIsLoading(true);
      const eventSlug = await getResolvedSlug();

      if (eventSlug) {
        const response = await getAllVenueBySlug(eventSlug);
        console.log(response);
        setTicketList(Array.isArray(response) ? response : []);
      }
    } catch (error) {
      console.error("Error loading venues:", error);
      setTicketList([]);
    } finally {
      setIsLoading(false);
    }
  };
  const columns = [
    // { label: 'VenueId', key: 'venueId', width: 90, hide: true },
    { label: "Venue Name", key: "venueName" },
    { label: "Venue Address", key: "venueAddress" },
    { label: "Event Date", key: "eventDate", },
    { label: "Status", key: "status" },
    {
    label: "Edit",
    key: "edit",
    pinned: 'right' as const, 
    cellContent: (row: any) => (
        <span className="d-flex justify-content-center align-items-center gap-4">
        <span
          className="text-primary cursor-pointer"
          onClick={() => handleEditClick(row)}
        >
        <i className="fa-solid fa-pen"></i>
        </span>
         <span className="text-danger cursor-pointer"
          onClick={() => handleDelete(row)} >
          <i className="fa-solid fa-trash"></i>
        </span>
        </span>
      )
    }
  ];
  const handleEditClick = (row: any) => {
  setEditData(row);
  setEditModal(true);
  }; 
  const handleEditSubmit = async () => {
    try {
      setIsLoading(true)
      if (!editData) return;
      const locationData = [{
        name: editData.venueName || "",
        venueName: editData.venueName || "",
        addressLine1: editData.venueAddress || editData.formattedAddress || "",
        addressLine2: "",
        city: editData.city || "",
        state: editData.state || "",
        country: editData.country || "",
        zipCode: editData.zipCode || "",
        latitude: editData.latitude,
        longitude: editData.longitude,
        formattedAddress: editData.formattedAddress || editData.venueAddress || "",
      }];
      const payload = {
        venueName: editData.venueName,
        venueAddress: editData.venueAddress,
        eventDate: editData.eventDate,
        status: editData.status,
        locationData: locationData,
      };
      await updateEventVenue(editData.venueId, payload);
      toast.success("Venue updated successfully");
      setEditModal(false);
      getTicketList();
    } catch (err) {
      toast.error("Failed to update venue");
    }
    finally{
      setIsLoading(false);
    }
  };
  // const handleSearch = (e: any) => {
  //   const search = e.target.value;
  //   setSearch(search);
  //   if (search.length > 0) {
  //     const tempTicketList = ticket.filter((ticket: any) =>
  //       ticket.ticketType.toLowerCase().includes(search.toLowerCase())
  //     );
  //     setTicketList(tempTicketList);
  //   } else {
  //     getTicketList();
  //   }
  // };
  const handleDelete = async (row: any) => {
      if (window.confirm("Are you sure you want to delete this venue?")) {
        try {
          const response = await deleteVenue(row.venueId);
          getTicketList();
          toast.success("venue deleted successfully!");
        } catch (error:any) {
          const errorMsg = error.response?.data?.message ||
                  "Failed to delete venue";
                toast.error(errorMsg);
        }
      }
    };
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
        venueName: "",
        venueAddress: "",
        eventDate: "",
        status: "active",
        city: "",
        state: "",
        country: "",
        zipCode: "",
        latitude: undefined,
        longitude: undefined,
        formattedAddress: "",
    },
    validationSchema: Yup.object({
        venueName: Yup.string().required("Ticket Name Required"),
        venueAddress: Yup.string().required("Ticket Address Required"),
        eventDate: Yup.string().required("Event Date Required"),
        status: Yup.string().required("Status Required"),

    }),
    onSubmit: async (values) => {
      try {
        setIsLoading(true)
        const eventData = localStorage.getItem("eventData");
        if (eventData) {
          const eventSlug = JSON.parse(eventData).slugId;
          const locationData = [{
            name: values.venueName || "",
            venueName: values.venueName || "",
            addressLine1: values.venueAddress || values.formattedAddress || "",
            addressLine2: "",
            city: values.city || "",
            state: values.state || "",
            country: values.country || "",
            zipCode: values.zipCode || "",
            latitude: values.latitude,
            longitude: values.longitude,
            formattedAddress: values.formattedAddress || values.venueAddress || "",
          }];

          const payload = {
            venueName: values.venueName,
            venueAddress: values.venueAddress,
            eventDate: values.eventDate,
            eventSlug, 
            status:"active",
            locationData: locationData,
          };
          const response = await createVenue(payload);
            getTicketList();
            toggle();
             toast.success("Venue Created successfully");
        }
      } catch (error: any) {
       toggle();
      const errorMsg =
        error.response?.data ||          
        "Failed to create venue";       
      toast.error(errorMsg);
    }
    finally{
      setIsLoading(false);
    }
    },
  });
  return (
    <div className={`contact-list-container ${isNightMode ? 'text-white' : 'text-dark'}`}>
      <Background />
      <PageHeader
        title="Venue Management"
        subtitle="Manage event venues, addresses, event dates, coordinates, and schedule locations."
        isLoading={isLoading}
        actions={
          <Button color="danger" onClick={toggle} className="v3-btn-primary h_40 d-flex align-items-center">
            <i className="fa-solid fa-plus me-2"></i> New Venue
          </Button>
        }
      />

      <div>
        <Modal isOpen={modal} toggle={toggle} modalClassName="quick-v2-glass-modal" size="lg">
          <ModalHeader toggle={toggle} className="border-bottom border-secondary">
            <span style={{ fontSize: '1.1rem', fontWeight: 600, letterSpacing: '0.5px' }}>
              📍 Add New Venue
            </span>
          </ModalHeader>
          <Form onSubmit={validation.handleSubmit}>
            <ModalBody className="p-4">
              <FormGroup>
                <Label className="text-uppercase text-secondary font-monospace" style={{ fontSize: '11px', letterSpacing: '1px' }}>
                  VENUE NAME *
                </Label>
                <Input
                  type="text"
                  placeholder="e.g. Grand Palace Convention Center"
                  name="venueName"
                  className="bg-dark text-white border-secondary"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.venueName}
                  invalid={
                    validation.touched.venueName &&
                    !!validation.errors.venueName
                  }
                />
                {validation.touched.venueName &&
                validation.errors.venueName ? (
                  <FormFeedback type="invalid" className="d-block text-danger mt-1">
                    {validation.errors.venueName}
                  </FormFeedback>
                ) : null}
              </FormGroup>                          
              <FormGroup>
                <Label className="text-uppercase text-secondary font-monospace" style={{ fontSize: '11px', letterSpacing: '1px' }}>
                  VENUE ADDRESS *
                </Label>
                <GooglePlacesAutocomplete
                  apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ""}
                  selectProps={{
                    placeholder: "Search for a venue address...",
                    isClearable: true,
                    value: validation.values.venueAddress ? {
                      label: validation.values.venueAddress,
                      value: validation.values.venueAddress
                    } : null,
                    onChange: (place: any) => {
                      if (place) {
                        validation.setFieldValue("venueAddress", place.label);
                        if (place.value?.place_id) {
                          const geocoder = new google.maps.Geocoder();
                          geocoder.geocode({ placeId: place.value.place_id }, (results, status) => {
                            if (status === "OK" && results && results[0]) {
                              const result = results[0];
                              validation.setFieldValue("formattedAddress", result.formatted_address || place.label);
                              validation.setFieldValue("latitude", result.geometry?.location?.lat());
                              validation.setFieldValue("longitude", result.geometry?.location?.lng());
                              
                              result.address_components.forEach((component) => {
                                if (component.types.includes("country")) {
                                  validation.setFieldValue("country", component.long_name);
                                } else if (component.types.includes("administrative_area_level_1")) {
                                  validation.setFieldValue("state", component.long_name);
                                } else if (component.types.includes("locality") || component.types.includes("administrative_area_level_2")) {
                                  validation.setFieldValue("city", component.long_name);
                                } else if (component.types.includes("postal_code")) {
                                  validation.setFieldValue("zipCode", component.long_name);
                                }
                              });
                            }
                          });
                        }
                      } else {
                        validation.setFieldValue("venueAddress", "");
                        validation.setFieldValue("formattedAddress", "");
                        validation.setFieldValue("latitude", undefined);
                        validation.setFieldValue("longitude", undefined);
                        validation.setFieldValue("city", "");
                        validation.setFieldValue("state", "");
                        validation.setFieldValue("country", "");
                        validation.setFieldValue("zipCode", "");
                      }
                    }
                  }}
                />
                {validation.touched.venueAddress &&
                validation.errors.venueAddress ? (
                  <div className="text-danger mt-1" style={{ fontSize: '0.875em' }}>
                    {validation.errors.venueAddress}
                  </div>
                ) : null}
              </FormGroup>
              <FormGroup>
                <Label className="text-uppercase text-secondary font-monospace" style={{ fontSize: '11px', letterSpacing: '1px' }}>
                  EVENT DATE
                </Label>
                <Input
                  type="date"
                  placeholder="Event Date"
                  name="eventDate"
                  className="bg-dark text-white border-secondary"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.eventDate}
                  invalid={
                    validation.touched.eventDate &&
                    !!validation.errors.eventDate
                  }
                />
                {validation.touched.eventDate &&
                validation.errors.eventDate ? (
                  <FormFeedback type="invalid" className="d-block text-danger mt-1">
                    {validation.errors.eventDate}
                  </FormFeedback>
                ) : null}
              </FormGroup>
            </ModalBody>
            <ModalFooter className="border-0 pt-0">
              <Button type="button" outline color="light" onClick={toggle} className="me-2 rounded-pill px-4">
                Cancel
              </Button>
              <Button color="primary" disabled={isLoading} type="submit" className="btn-primary rounded-pill px-4">
                <i className="fa-solid fa-floppy-disk me-2"></i>
                {isLoading ? "Creating..." : "Save Venue"}
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
        <Modal isOpen={editModal} toggle={() => setEditModal(!editModal)} modalClassName="quick-v2-glass-modal" size="lg">
          <ModalHeader toggle={() => setEditModal(!editModal)} className="border-bottom border-secondary">
            <span style={{ fontSize: '1.1rem', fontWeight: 600, letterSpacing: '0.5px' }}>
              📍 Edit Venue
            </span>
          </ModalHeader>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              handleEditSubmit();
            }}
          >
            <ModalBody className="p-4">
              <FormGroup>
                <Label className="text-uppercase text-secondary font-monospace" style={{ fontSize: '11px', letterSpacing: '1px' }}>
                  VENUE NAME *
                </Label>
                <Input
                  type="text"
                  className="bg-dark text-white border-secondary"
                  value={editData?.venueName || ""}
                  onChange={(e) =>
                    setEditData({ ...editData, venueName: e.target.value })
                  }
                />
              </FormGroup>
              <FormGroup>
                <Label className="text-uppercase text-secondary font-monospace" style={{ fontSize: '11px', letterSpacing: '1px' }}>
                  VENUE ADDRESS *
                </Label>
                <GooglePlacesAutocomplete
                  apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ""}
                  selectProps={{
                    placeholder: "Search for a venue address...",
                    isClearable: true,
                    value: editData?.venueAddress ? {
                      label: editData.venueAddress,
                      value: editData.venueAddress
                    } : null,
                    onChange: (place: any) => {
                      if (place) {
                        let updatedData = { ...editData, venueAddress: place.label };
                        setEditData(updatedData);
                        if (place.value?.place_id) {
                          const geocoder = new google.maps.Geocoder();
                          geocoder.geocode({ placeId: place.value.place_id }, (results, status) => {
                            if (status === "OK" && results && results[0]) {
                              const result = results[0];
                              updatedData = {
                                ...updatedData,
                                formattedAddress: result.formatted_address || place.label,
                                latitude: result.geometry?.location?.lat(),
                                longitude: result.geometry?.location?.lng(),
                              };
                              result.address_components.forEach((component) => {
                                if (component.types.includes("country")) {
                                  updatedData.country = component.long_name;
                                } else if (component.types.includes("administrative_area_level_1")) {
                                  updatedData.state = component.long_name;
                                } else if (component.types.includes("locality") || component.types.includes("administrative_area_level_2")) {
                                  updatedData.city = component.long_name;
                                } else if (component.types.includes("postal_code")) {
                                  updatedData.zipCode = component.long_name;
                                }
                              });
                              setEditData(updatedData);
                            }
                          });
                        }
                      } else {
                        setEditData({
                          ...editData,
                          venueAddress: "",
                          formattedAddress: "",
                          latitude: undefined,
                          longitude: undefined,
                          city: "",
                          state: "",
                          country: "",
                          zipCode: ""
                        });
                      }
                    }
                  }}
                />
              </FormGroup>
              <FormGroup>
                <Label className="text-uppercase text-secondary font-monospace" style={{ fontSize: '11px', letterSpacing: '1px' }}>
                  EVENT DATE
                </Label>
                <Input
                  type="date"
                  className="bg-dark text-white border-secondary"
                  value={editData?.eventDate || ""}
                  onChange={(e) =>
                    setEditData({ ...editData, eventDate: e.target.value })
                  }
                />
              </FormGroup>
              <FormGroup>
                <Label className="text-uppercase text-secondary font-monospace" style={{ fontSize: '11px', letterSpacing: '1px' }}>
                  STATUS
                </Label>
                <Input
                  type="select"
                  className="bg-dark text-white border-secondary"
                  value={editData?.status || "active"}
                  onChange={(e) =>
                    setEditData({ ...editData, status: e.target.value })
                  }
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </Input>
              </FormGroup>
            </ModalBody>
            <ModalFooter className="border-0 pt-0">
              <Button type="button" outline color="light" onClick={() => setEditModal(false)} className="me-2 rounded-pill px-4">
                Cancel
              </Button>
              <Button color="primary" disabled={isLoading} type="submit" className="btn-primary rounded-pill px-4">
                <i className="fa-solid fa-floppy-disk me-2"></i>
                {isLoading ? "Saving..." : "Save Venue"}
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      </div>
                    <div>
                      <ToastContainer autoClose={2000} />
                    </div>
                    {isLoading ? (
                      <div className="d-flex justify-content-center py-4">
                        <PulseLoader color="#ffffff" size={9} speedMultiplier={1} />
                      </div>
                    ) : (
                      <div className="mt-4">
                        {ticket.length > 0 ? (
                          ticket.map((tickets: any) => (
                            <ListCard
                              key={tickets.venueId}
                              cardData={{
                                icon: "fa-solid fa-building",
                                name: tickets.venueName,
                                ticket: `(${tickets.venueAddress})`,
                                startDate: tickets.createdAt,
                                status: tickets.status,
                                optionHead1: "Event Date",
                                option1: tickets.eventDate,
                                optionIcon1: "fa-solid fa-calendar",
                                optionHead: "Venue Address",
                                option: tickets.venueAddress,
                              }}
                              onEdit={() => handleEditClick(tickets)}
                              onDelete={() => handleDelete(tickets)}
                            />
                          ))
                        ) : (
                          <p className="text-muted">No venues available</p>
                        )}
                      </div>
                    )}
                  </div>
    
  );
};

export default Venue;